import React from 'react';

class CanvasErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Canvas rendering error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Return custom fallback UI or nothing (collapsing the canvas gracefully)
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}

export default CanvasErrorBoundary;
